import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'

import {useApolloClient} from '@apollo/client'
import {t} from 'i18next'

import PageLoader from '@progyny/components/PageLoader'
import {useLogoutMutation} from '@progyny/generated/graphql'
import {RouteEnum, useQuery, useRoutes} from '@progyny/routes'

const Logout = (): JSX.Element => {
  const [logoutMutation] = useLogoutMutation()
  const apollo = useApolloClient()
  const history = useHistory()
  const query = useQuery()
  const {getPath} = useRoutes()

  function clearStoreThenLogout() {
    // Clearing store needed to not refetch queries. Apparently resetStore
    // is a cache reset, rather than store cleaning.
    // https://github.com/apollographql/apollo-client/issues/2774
    apollo
      .clearStore()
      .then(() => {
        apollo
          .resetStore()
          .then(() => {
            logoutMutation()
              .catch((error) => {
                console.error(error)
              })
              .finally(() => {
                let next = getPath(RouteEnum.LOGIN)
                if (query.has('next')) {
                  try {
                    next = decodeURI(query.get('next') as string)
                  } catch (e) {
                    console.error(e)
                  }
                }
                history.push(next)
              })
          })
          .catch((error) => {
            console.error(error)
          })
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    clearStoreThenLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <PageLoader loadingMessage={t('logging_out')} position={'center'} />
}

export default Logout
